const DUMMY_RESUME = {
    heading: {
        fname: "Jessie",
        lname: "Smith",
        profession: "Human Resource Manager",
        address: "4759 Sunnydale Lane",
        city: "Plano",
        state: "TX",
        zipcode: "75071",
        phone: "(469) 385-2948",
        email: "email@youremail.com",
        address_visibility: 'yes'
    },
    socials: {
    },
    work_history: {
        jobs: {
            job_1: {
                job: {
                    job_title: "Human Resources Manager",
                    employer: "Jim's Widget Factory",
                    city: "Plano",
                    state: "TX",
                    start_date: "January 2016",
                    end_date: "",
                    currently_working: true,
                    description:
                        "<ul> \
                        <li>Implement effective company policies to ensure that all practices comply with labor and employment regulations </li> \
                        <li>Increased employee retention rates by managing workplace satisfaction to an over 90% success rate by creating and maintaining a positive work environment </li> \
                        <li>Develop targeted outreach practices to increase minority recruitment and ensure compliance with affirmative action policies </li> \
                        <li>Monitor scheduled in and out times as well as employee breaks to ensure that proper employment laws are met </li> \
                        </ul>",
                },
            },
            job_2: {
                job: {
                    job_title: "Human Resources Associate",
                    employer: "Jim's Widget Factory",
                    city: "Plano",
                    state: "TX",
                    start_date: "March 2015",
                    end_date: "January 2016",
                    currently_working: false,
                    description:
                        "<ul> \
                        <li>Implement effective company policies to ensure that all practices comply with labor and employment regulations </li> \
                        <li>Increased employee retention rates by managing workplace satisfaction to an over 90% success rate by creating and maintaining a positive work environment </li> \
                        <li>Develop targeted outreach practices to increase minority recruitment and ensure compliance with affirmative action policies </li> \
                        </ul>",
                },
            },
        },
    },
    education_history: {
        all: {
            education_1: {
                education: {
                    school_name: "The University of Texas",
                    school_location: "Dallas",
                    degree: "Masters",
                    field_of_study: "Human Resources",
                    start_date: "September 2007",
                    end_date: "May 2011",
                    currently_studying: false,
                    description:
                        "<ul> <li>Academic Awardee of AY 2007-2008</li>  </ul>",
                },
            },
        },
    },
    summary: { content: '<p>Human resources generalist with 8 years of experience in HR, including hiring and terminating, disciplining employees and helping department managers improve employee performance. Worked with labor unions to negotiate compensation packages for workers. Organized new hire training initiatives as well as ongoing training to adhere to workplace safety standards. Worked with OSHA to ensure that all safety regulations are followed.</p>' },
    skills: {
        set: {
            skill_1: { rating: 3, name: 'Detail oriented' },
            skill_2: { rating: 3, name: 'Well-versed in Texas employment law' },
            skill_3: { rating: 3, name: 'Excellent written and oral communication skills' },
            skill_4: { rating: 3, name: 'Develops positive workplace relationships' },
        }
    },
    certificates:{
        name: 'Certifications',
        set: {
          '0': {
            date: 'September 2020',
            name: 'Professional in Human Resources',
            institution: 'Human Resource Certification Institute (HRCI)',
            content: 'I earned the Professional in Human Resources certificate from the Human Resource Certification Institute (HRCI).',
            url: 'https://www.hrci.org/certifications/individual-certifications/phr',
            open: false
          }
        },
        'new': true
      }
}
export const DUMMY_LETTERS = {
        from: {
            fname: "Chris Candidate",
            addressline1: "456 My Street",
            addressline2: "San Francisco, CA 76543",
            phone: "(098) 765-4321",
            email: "example@myemail.com",
          },
          summary: {
            content:"<p>Dear [Send to],</p><p>Achieving a 90% pass rate in my second year of teaching was the highlight of my career as a teacher so far. I hope to replicate and exceed these excellent results at George Washington High.</p><p>As an ambitious and hard-working English teacher, I am drawn to the results-driven and inclusive working environment at George Washington High and feel that my character and commitment goals make me a good fit.</p><p>I relish the opportunity to bring my skills to your school and develop my practice further. My achievements to date include:</p><ul><li>Being recognized as the top-performing newly-qualified teacher in my school during 2019</li><li>Achieving a 10% improvement in results for students with SEN in my subject area last year</li><li>Setting up and running a successful student drama society and staging several plays</li></ul><p>I would be excited to arrange an interview to discuss how my skills and experience can benefit the students at George Washington High. Please let me know what time is convenient for you.</p><p>Sincerely,</p><p>Alesha Dean</p><p>P.S. I look forward to telling you why I was nominated for a Global Teacher Prize in 2020.</p>",
            date: "[month day, year]"
        },
        to: {
            fname: "FULL NAME",
            company: "COMPANY NAME",
            addresstoline1: "123 Your Street,",
            addresstoline2: "",
            phone: "(123) 456-7890",
            email: "example@youremail.com",
        }
}
export default DUMMY_RESUME;



